import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import './assets/tailwind.css'
import './assets/main.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en'

Vue.use(ElementUI, { locale })
Vue.config.productionTip = false

// Глобал валютын формат фильтерүүд
Vue.filter('formatCurrency', function (value) {
  return new Intl.NumberFormat().format(value) + '₮'
})

Vue.filter('formatCurrencyYuan', function (value) {
  return new Intl.NumberFormat().format(value) + '¥'
})

Vue.filter('formatCurrencyJin', function (value) {
  return new Intl.NumberFormat().format(value)
})

new Vue({
  router,
  store,
  data: {
    fullscreenLoading: false,
    trackCodeDetailDialog: false,
    statusArray: [
      {
        id: 1,
        value: 100,
        label: ' Хэрэглэгч бүртгэсэн'
      },
      {
        id: 2,
        value: 110,
        label: ' Эрээн дах агуулхаас гарсан'
      },
      {
        id: 3,
        value: 120,
        label: 'Монгол дах салбар хүлээн авсан'
      },
      {
        id: 4,
        value: 200,
        label: ' Хэрэглэгч хүлээн авсан'
      },
      {
        id: 5,
        value: 130,
        label: ' Хэрэглэгч хүргэлтээр авна'
      },
      {
        id: 6,
        value: 140,
        label: ' Хэрэглэгч салбараас очиж авна'
      },
      {
        id: 7,
        value: 150,
        label: ' Хэрэглэгч салбар дээр хадгалуулна'
      },
      {
        id: 8,
        value: 160,
        label: ' Хүргэлтийн ажилтанд хуваарилсан'
      },
      {
        id: 9,
        value: 170,
        label: ' Ачаа салбар дээр үлдсэн'
      },
      {
        id: 10,
        value: 180,
        label: ' Трак код шалгуулах'
      },
      {
        id: 11,
        value: 190,
        label: ' Цуцалсан'
      },
      {
        id: 12,
        value: 210,
        label: ' Багц'
      }
    ],
    cargoStatus: [
      {
        id: 1,
        value: 100,
        label: ' Эрээн дах агуулхаас гарсан'
      },
      {
        id: 2,
        value: 110,
        label: 'Хүргэлтийн ажилтан хүлээн авсан'
      },
      {
        id: 4,
        value: 130,
        label: 'Салбар хүлээн авсан'
      },
      {
        id: 5,
        value: 140,
        label: 'Асуудалтай ачаа'
      }
    ],
    trackCodeDialogVisible: false,
    checkTrackCodes: false,
    checkHvrgelt: false,
    addAddressDialog: false,
    giveUserDialog: false,
    giveUserAndPaymentDialog: false,
    hvrgeltendGargahAndPaymentDialog: false,
    progressDialog: false,
    cargoDetailDialog: false,
    crudCargoDetailDialog: false,
    deliveryDetailDialog: false,
    progressDetailDialog: false,
    checkTrackCodeDialog: false
  },
  render: h => h(App)
}).$mount('#app')
